/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mimzad ERP API
 * Core and Shared Event Backbone API for Mimzad ERP
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PaginatedTicketList,
  PatchedTicket,
  SupportTicketsListParams,
  Ticket
} from '.././models';

import { customAxiosInstance } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;





/**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsList = (
    params?: SupportTicketsListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<PaginatedTicketList>(
      {url: `/api/support/tickets/`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSupportTicketsListQueryKey = (params?: SupportTicketsListParams,) => {
    return [
    `/api/support/tickets/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportTicketsListQueryOptions = <TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportTicketsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportTicketsList>>> = ({ signal }) => supportTicketsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SupportTicketsListQueryResult = NonNullable<Awaited<ReturnType<typeof supportTicketsList>>>
export type SupportTicketsListQueryError = unknown


export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params: undefined |  SupportTicketsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsList>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsList>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSupportTicketsList<TData = Awaited<ReturnType<typeof supportTicketsList>>, TError = unknown>(
 params?: SupportTicketsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSupportTicketsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsCreate = (
    ticket: NonReadonly<Ticket>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ticket, signal
    },
      );
    }
  


export const getSupportTicketsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreate>>, TError,{data: NonReadonly<Ticket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreate>>, TError,{data: NonReadonly<Ticket>}, TContext> => {

const mutationKey = ['supportTicketsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsCreate>>, {data: NonReadonly<Ticket>}> = (props) => {
          const {data} = props ?? {};

          return  supportTicketsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsCreate>>>
    export type SupportTicketsCreateMutationBody = NonReadonly<Ticket>
    export type SupportTicketsCreateMutationError = unknown

    export const useSupportTicketsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreate>>, TError,{data: NonReadonly<Ticket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsCreate>>,
        TError,
        {data: NonReadonly<Ticket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsRetrieve = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/${id}/`, method: 'GET', signal
    },
      );
    }
  



export const getSupportTicketsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/support/tickets/${id}/`
    ] as const;
    }

    
export const getSupportTicketsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportTicketsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportTicketsRetrieve>>> = ({ signal }) => supportTicketsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SupportTicketsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof supportTicketsRetrieve>>>
export type SupportTicketsRetrieveQueryError = unknown


export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportTicketsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof supportTicketsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSupportTicketsRetrieve<TData = Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportTicketsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSupportTicketsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsUpdate = (
    id: string,
    ticket: NonReadonly<Ticket>,
 ) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: ticket
    },
      );
    }
  


export const getSupportTicketsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsUpdate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsUpdate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext> => {

const mutationKey = ['supportTicketsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsUpdate>>, {id: string;data: NonReadonly<Ticket>}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsUpdate>>>
    export type SupportTicketsUpdateMutationBody = NonReadonly<Ticket>
    export type SupportTicketsUpdateMutationError = unknown

    export const useSupportTicketsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsUpdate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsUpdate>>,
        TError,
        {id: string;data: NonReadonly<Ticket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsPartialUpdate = (
    id: string,
    patchedTicket: NonReadonly<PatchedTicket>,
 ) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedTicket
    },
      );
    }
  


export const getSupportTicketsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedTicket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedTicket>}, TContext> => {

const mutationKey = ['supportTicketsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsPartialUpdate>>, {id: string;data: NonReadonly<PatchedTicket>}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsPartialUpdate>>>
    export type SupportTicketsPartialUpdateMutationBody = NonReadonly<PatchedTicket>
    export type SupportTicketsPartialUpdateMutationError = unknown

    export const useSupportTicketsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsPartialUpdate>>, TError,{id: string;data: NonReadonly<PatchedTicket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsPartialUpdate>>,
        TError,
        {id: string;data: NonReadonly<PatchedTicket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsDestroy = (
    id: string,
 ) => {
      
      
      return customAxiosInstance<void>(
      {url: `/api/support/tickets/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getSupportTicketsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsDestroy>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['supportTicketsDestroy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  supportTicketsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsDestroy>>>
    
    export type SupportTicketsDestroyMutationError = unknown

    export const useSupportTicketsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsDestroy>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSupportTicketsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsAttachmentsCreate = (
    id: string,
    ticket: NonReadonly<Ticket>,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(ticket.status !== undefined) {
 formData.append(`status`, ticket.status)
 }
if(ticket.priority !== undefined) {
 formData.append(`priority`, ticket.priority)
 }
formData.append(`subject`, ticket.subject)
if(ticket.description !== undefined) {
 formData.append(`description`, ticket.description)
 }
if(ticket.department !== undefined && ticket.department !== null) {
 formData.append(`department`, ticket.department)
 }
if(ticket.assigned_to !== undefined && ticket.assigned_to !== null) {
 formData.append(`assigned_to`, ticket.assigned_to)
 }

      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/${id}/attachments/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getSupportTicketsAttachmentsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsAttachmentsCreate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsAttachmentsCreate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext> => {

const mutationKey = ['supportTicketsAttachmentsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsAttachmentsCreate>>, {id: string;data: NonReadonly<Ticket>}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsAttachmentsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsAttachmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsAttachmentsCreate>>>
    export type SupportTicketsAttachmentsCreateMutationBody = NonReadonly<Ticket>
    export type SupportTicketsAttachmentsCreateMutationError = unknown

    export const useSupportTicketsAttachmentsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsAttachmentsCreate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsAttachmentsCreate>>,
        TError,
        {id: string;data: NonReadonly<Ticket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsAttachmentsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsForwardCreate = (
    id: string,
    ticket: NonReadonly<Ticket>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/${id}/forward/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ticket, signal
    },
      );
    }
  


export const getSupportTicketsForwardCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsForwardCreate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsForwardCreate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext> => {

const mutationKey = ['supportTicketsForwardCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsForwardCreate>>, {id: string;data: NonReadonly<Ticket>}> = (props) => {
          const {id,data} = props ?? {};

          return  supportTicketsForwardCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsForwardCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsForwardCreate>>>
    export type SupportTicketsForwardCreateMutationBody = NonReadonly<Ticket>
    export type SupportTicketsForwardCreateMutationError = unknown

    export const useSupportTicketsForwardCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsForwardCreate>>, TError,{id: string;data: NonReadonly<Ticket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsForwardCreate>>,
        TError,
        {id: string;data: NonReadonly<Ticket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsForwardCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsForwardsIncludeAttachmentCreate = (
    id: string,
    forwardPk: string,
    attachmentPk: string,
    ticket: NonReadonly<Ticket>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/${id}/forwards/${forwardPk}/include-attachment/${attachmentPk}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ticket, signal
    },
      );
    }
  


export const getSupportTicketsForwardsIncludeAttachmentCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsForwardsIncludeAttachmentCreate>>, TError,{id: string;forwardPk: string;attachmentPk: string;data: NonReadonly<Ticket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsForwardsIncludeAttachmentCreate>>, TError,{id: string;forwardPk: string;attachmentPk: string;data: NonReadonly<Ticket>}, TContext> => {

const mutationKey = ['supportTicketsForwardsIncludeAttachmentCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsForwardsIncludeAttachmentCreate>>, {id: string;forwardPk: string;attachmentPk: string;data: NonReadonly<Ticket>}> = (props) => {
          const {id,forwardPk,attachmentPk,data} = props ?? {};

          return  supportTicketsForwardsIncludeAttachmentCreate(id,forwardPk,attachmentPk,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsForwardsIncludeAttachmentCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsForwardsIncludeAttachmentCreate>>>
    export type SupportTicketsForwardsIncludeAttachmentCreateMutationBody = NonReadonly<Ticket>
    export type SupportTicketsForwardsIncludeAttachmentCreateMutationError = unknown

    export const useSupportTicketsForwardsIncludeAttachmentCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsForwardsIncludeAttachmentCreate>>, TError,{id: string;forwardPk: string;attachmentPk: string;data: NonReadonly<Ticket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsForwardsIncludeAttachmentCreate>>,
        TError,
        {id: string;forwardPk: string;attachmentPk: string;data: NonReadonly<Ticket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsForwardsIncludeAttachmentCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ADR-110. Uses DefaultRouter (never SimpleRouter, per project rule).

- list/retrieve/create/update: internal tickets, any authenticated user
  restricted to their own department/created tickets (queryset scoping
  left to the real project's tenancy/RLS middleware — see ADR-059).
- create_vendor: gated by IsSupportManager -> can_create_vendor_ticket.
- forward: gated by IsSupportManager -> can_forward_to_vendor.
 */
export const supportTicketsCreateVendorCreate = (
    ticket: NonReadonly<Ticket>,
 signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<Ticket>(
      {url: `/api/support/tickets/create-vendor/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ticket, signal
    },
      );
    }
  


export const getSupportTicketsCreateVendorCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreateVendorCreate>>, TError,{data: NonReadonly<Ticket>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreateVendorCreate>>, TError,{data: NonReadonly<Ticket>}, TContext> => {

const mutationKey = ['supportTicketsCreateVendorCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportTicketsCreateVendorCreate>>, {data: NonReadonly<Ticket>}> = (props) => {
          const {data} = props ?? {};

          return  supportTicketsCreateVendorCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportTicketsCreateVendorCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportTicketsCreateVendorCreate>>>
    export type SupportTicketsCreateVendorCreateMutationBody = NonReadonly<Ticket>
    export type SupportTicketsCreateVendorCreateMutationError = unknown

    export const useSupportTicketsCreateVendorCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportTicketsCreateVendorCreate>>, TError,{data: NonReadonly<Ticket>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportTicketsCreateVendorCreate>>,
        TError,
        {data: NonReadonly<Ticket>},
        TContext
      > => {

      const mutationOptions = getSupportTicketsCreateVendorCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    